export default __webpack_public_path__ + "static/media/4.581c987a.jpeg";